import { em, rem } from 'polished';
import { theme as base } from '@qga/components';
import { keyframes as emotionKeyframes } from '@emotion/core';
import * as extraIcons from './icons';

export const BREAK_POINTS_PX = [768, 1100, 1280];

// TODO Move onto standardised font sizes: https://app.shortcut.com/qantasaccommodation/story/93842/self-service-use-standardised-font-sizes-across-the-app
const fontSizes = {
  xs: rem('13px'),
  sm: rem('15px'),
  base: rem('16px'),
  lg: rem('18px'),
  xl: rem('22px'),
  '2xl': rem('26px'),
  '3xl': rem('36px'),
  '4xl': rem('46px'),
};

const colors = {
  ...base.colors,
  riptide: '#8DE2E1',
  emperor: '#555555',
  puertoRico: '#40c9c6',
};

const borders = [0, `${rem('1px')} solid`, `${rem('2px')} solid`, `${rem('3px')} solid`];

const letterSpacings = {
  ...base.letterSpacings,
  medium: em('1px'),
};

const radii = {
  ...base.radii,
  default: rem('4px'),
  heavy: rem('12px'),
  rounded: '50%',
};

const heights = {
  borderThin: rem('1px'),
  pageHeader: rem('152px'),
};

const minHeights = {
  modal: rem('700px'),
};

const fontWeights = {
  ...base.fontWeights,
  normal: 400,
  bold: 600,
};

const textStyles = {
  ...base.textStyles,
  label: {
    fontWeight: fontWeights.normal,
  },
  text: {
    lineHeight: base.lineHeights.normal,
  },
  visuallyHidden: {
    position: 'absolute !important',
    height: '1px',
    width: '1px',
    overflow: 'hidden',
    clip: 'rect(1px, 1px, 1px, 1px)',
  },
  link: {
    display: 'inline-block',
    color: colors.ui.link,
    '&:hover': {
      color: colors.ui.linkHover,
    },
    '&.hidden': {
      display: 'none',
    },
  },
  externalLink: {
    display: 'inline-block',
    color: colors.greys.steel,
    textDecoration: 'none',
    '&:hover': {
      color: colors.ui.linkHover,
    },
    '&:active': {
      color: colors.ui.link,
    },
    '&:focus': {
      outline: `1px dotted ${colors.greys.steel}`,
    },
  },
};

const breakpoints = BREAK_POINTS_PX.map((bp) => rem(`${bp}px`));

const mediaQueries = BREAK_POINTS_PX.map((n) => `@media screen and (min-width: ${n}px)`);

const maxWidths = {
  ...base.maxWidths,
  default: rem('1260px'), // TODO: update to rem('1500px') when EDS header is ready for release - content to match the EDS header width
  legacyWrapper: rem('1025px'),
  modal: rem('600px'),
  login: rem('490px'),
};

const zIndices = {
  header: 100,
  alerts: 101,
  phoneMenuDrawer: 501,
  phoneMenuDrawerClose: 502,
  poppers: 503,
  processingScreen: 600,
  modalOverlay: 700,
};

const shadows = {
  ...base.shadows,
  dropdown: '0 4px 8px rgba(0, 0, 0, 0.25)',
  modal: '0 4px 10px 0 rgba(0, 0, 0, 0.1)',
  footer: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
};

const icons = {
  ...base.icons,
  ...extraIcons,
};

const transitions = {
  ...base.transitions,
  delayedCollapse: '200ms ease 2s',
  quickFadeIn: '200ms ease-in-out',
};

const keyframes = {
  fadeIn: emotionKeyframes`
    from { opacity: 0; }
    to { opacity: 1; }
  `,
};

const mediaQueriesMaxWidth = BREAK_POINTS_PX.map((px) => `@media screen and (max-width: ${rem(px - 1)})`);

const minWidths = {
  sidebar: rem(320),
};

export default {
  ...base,
  icons,
  shadows,
  colors,
  breakpoints,
  mediaQueries,
  maxWidths,
  zIndices,
  heights,
  minHeights,
  borders,
  radii,
  fontWeights,
  textStyles,
  transitions,
  keyframes,
  letterSpacings,
  mediaQueriesMaxWidth,
  minWidths,
  fontSizes,
};
